export default __webpack_public_path__ + "static/media/n.3dcea01b.mp4";